import { REAL_ESTATE_TYPES, REAL_ESTATE_USAGES } from 'cpool-constants';
import { z } from 'zod';

import { regex_iso_date } from '../../../utils/regex.utils';
import { schemaBigDecimal, schemaInteger } from '../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#immobilie

	{
		"bezeichnung": String,
		"darlehen": [
			{
				"restschuld": schemaBigDecimal,
				"zinsbindungBis": "YYYY-MM-DD",
				"rateMonatlich": schemaBigDecimal
			}
		],
		"gehoertZuAntragsteller": Antragstellerzuordnung,
		"immobilienart": "EIGENTUMSWOHNUNG" | "EINFAMILIENHAUS" | "MEHRFAMILIENHAUS" | "BUEROGEBAEUDE",
		"mieteinnahmenKaltMonatlich": schemaBigDecimal,
		"mieteinnahmenWarmMonatlich": schemaBigDecimal,
		"nebenkostenMonatlich": schemaBigDecimal,
		"nutzungsart": "EIGENGENUTZT" | "VERMIETET" | "EIGENGENUTZT_UND_VERMIETET",
		"vermieteteWohnflaeche": schemaInteger,
		"wert": schemaBigDecimal,
		"wohnflaeche": schemaInteger
	}

*/
export const schemaEuropaceImmobilie = z.object({
    bezeichnung: z.optional(z.string()),
    darlehen: z.optional(
        z.array(
            z.object({
                rateMonatlich: z.optional(schemaBigDecimal),
                restschuld: z.optional(schemaBigDecimal),
                zinsbindungBis: z.optional(z.string().regex(regex_iso_date)),
            }),
        ),
    ),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    id: z.string().min(1),
    immobilienart: z.optional(z.nativeEnum(REAL_ESTATE_TYPES)),
    mieteinnahmenKaltMonatlich: z.optional(schemaBigDecimal),
    mieteinnahmenWarmMonatlich: z.optional(schemaBigDecimal),
    nebenkostenMonatlich: z.optional(schemaBigDecimal),
    nutzungsart: z.optional(z.nativeEnum(REAL_ESTATE_USAGES)),
    vermieteteWohnflaeche: z.optional(schemaInteger),
    wert: z.optional(schemaBigDecimal),
    wohnflaeche: z.optional(schemaInteger),
});

export type SchemaEuropaceImmobilie = z.infer<typeof schemaEuropaceImmobilie>;
